import { apiRequest } from '../../ConversationPage/apis/client';

import {
  ImproveCustomRuleRequest,
  ImproveCustomRuleResponse,
  LexOfficeRuleset,
  UpsertLexOfficeRulesetRequest,
} from './types';

// Get the LexOffice ruleset for authenticated user
export const getLexOfficeRuleset = async (
  token: string
): Promise<LexOfficeRuleset | null> => {
  return apiRequest<LexOfficeRuleset | null>({
    endpoint: '/lex-office-rulesets',
    method: 'GET',
    token,
  });
};

// Create or update the LexOffice ruleset
export const upsertLexOfficeRuleset = async (
  data: UpsertLexOfficeRulesetRequest,
  token: string
): Promise<LexOfficeRuleset> => {
  return apiRequest<LexOfficeRuleset>({
    endpoint: '/lex-office-rulesets',
    method: 'POST',
    body: data,
    token,
  });
};

// Improve a custom rule using AI
export const improveCustomRule = async (
  data: ImproveCustomRuleRequest,
  token: string
): Promise<ImproveCustomRuleResponse> => {
  return apiRequest<ImproveCustomRuleResponse>({
    endpoint: '/lex-office-rulesets/improve-custom-rule',
    method: 'POST',
    body: data,
    token,
  });
};

// Delete the LexOffice ruleset
export const deleteLexOfficeRuleset = async (
  token: string
): Promise<{ message: string }> => {
  return apiRequest<{ message: string }>({
    endpoint: '/lex-office-rulesets',
    method: 'DELETE',
    token,
  });
};
